/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiEducations/guiEducationsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiEducationEditForm } from "./GuiEducationEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiEducation = {
  id: undefined,
  guideId: 0,
  degreeType: "",
  examName: "",
  passingYear: "",
  subjectStudied: "",
  percentage: "",
  university: "",
};
export function GuiEducationEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiEducationForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiEducations.actionsLoading,
      guiEducationForEdit: state.guiEducations.guiEducationForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiEducation(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide Education";
    if (guiEducationForEdit && id) {
      _title = `Edit Guide Education`;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiEducationForEdit, id]);

  const saveGuiEducation = (values) => {
    if (!id) {
      dispatch(actions.createGuiEducation(values)).then(() =>
        backToGuiEducationsList()
      );
    } else {
      dispatch(actions.updateGuiEducation(values)).then(() =>
        backToGuiEducationsList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiEducationClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };


  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/guiEducation/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
 
 
 
  initGuiEducation.guideId=GuideId;

  console.log(GuideId)

  const backToGuiEducationsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiEducationsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiEducationClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiEducationEditForm
                  actionsLoading={actionsLoading}
                  guiEducation={guiEducationForEdit || initGuiEducation}
                  btnRef={btnRef}
                  saveGuiEducation={saveGuiEducation}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
